import { PeopleContainer, PeopleSettingLandingPageHeader } from "pages/Preferences/People/PeopleSettingsPage.styles.ts";
import { useParams } from "react-router";
import { useGetUsersQuery } from "features/api/permissionsApi.ts";
import { formatPersonName } from "components/Preferences/preferencesUtils.ts";
import PersonCommunicationSettings from "components/Preferences/PeopleSettings/PersonCommunicationSettings.tsx";
import PersonSettingsSkeleton from "components/Preferences/PeopleSettings/PersonSettingsSkeleton.tsx";
import { useGetUserDetailsQuery } from "features/api/userApi.ts";
import ConfigurationsContext from "context/configurations/ConfigurationsContext.ts";
import { useContext } from "react";
import APIErrorCustomBanner from "components/Common/APIErrorCustomBanner/APIErrorCustomBanner.tsx";
import { UserPermission } from "types/declarations/enums.ts";

const PersonSettingsPage = () => {
	const { userId } = useParams();
	const { data: people, isLoading } = useGetUsersQuery();
	const person = people?.find((p) => p.userId === userId);
	const { data: userDetails } = useGetUserDetailsQuery();
	const isAdmin = userDetails?.permissions?.find((x) => x === UserPermission.ADMIN) ?? false;
	const { configurationsData } = useContext(ConfigurationsContext);
	const isUserPreferenceEnabled = configurationsData?.featureFlags?.userPreferenceEnabled ?? false;

	const getPageHeader = () => {
		if (person) {
			return `Settings for ${formatPersonName(person)}`;
		}

		return "Settings";
	};
	if (!isAdmin || !isUserPreferenceEnabled) {
		return (
			<div>
				<APIErrorCustomBanner statusCode={403} />
			</div>
		);
	}
	return (
		<>
			<PeopleSettingLandingPageHeader>
				<h1>{getPageHeader()}</h1>
			</PeopleSettingLandingPageHeader>
			{isLoading ? (
				<PersonSettingsSkeleton />
			) : (
				<PeopleContainer>
					<PersonCommunicationSettings person={person} />
				</PeopleContainer>
			)}
		</>
	);
};

export default PersonSettingsPage;
